import axios from 'axios';
export const errCheck = (err) => {
    if (err.response.data.statusCode == '401') {
        localStorage.removeItem('token');
        window.location.href = '/login';
    }
};
export default class StatisticsService {
    async shopCategoryList(sName, schild, age_grp, gend,m_stat,spet,s_date,e_date,c_age,min_pri,max_pri,) {
        return await axios
            .post(`/report/shop_category`, {
                shop_name:sName,
                children:schild,
                user_age_group:age_grp,
                gender:gend,
                marital_status:m_stat,
                pet:spet,
                start_date:s_date,
                end_date:e_date,
                children_age:c_age,
                min_price:min_pri,
                max_price:max_pri
                
            })
            .then((res) => res.data.data) .catch((err) => {
                errCheck(err);
            });
    }
    async getExcelshopCategory(sName, schild, age_grp, gend,m_stat,spet,s_date,e_date,c_age,min_pri,max_pri,dreason) {
        return await axios({
            url: `/report/shop_category/download`,
            method: 'POST',
            responseType: 'blob', // important
            data: {
                shop_name:sName,
                children:schild,
                user_age_group:age_grp,
                gender:gend,
                marital_status:m_stat,
                pet:spet,
                start_date:s_date,
                end_date:e_date,
                children_age:c_age,
                min_price:min_pri,
                max_price:max_pri,
                reason:dreason,
            },
        }).then((res) => res) .catch((err) => {
            errCheck(err);
        });
    }
    async shopCategoryIdList(ids,sName, schild, age_grp, gend,m_stat,spet,s_date,e_date,c_age,min_pri,max_pri) {
        return await axios
            .post(`/report/shop_category/shop`, {
                category_id:ids,
                shop_name:sName,
                children:schild,
                user_age_group:age_grp,
                gender:gend,
                marital_status:m_stat,
                pet:spet,
                start_date:s_date,
                end_date:e_date,
                children_age:c_age,
                min_price:min_pri,
                max_price:max_pri
            })
            .then((res) => res.data.data) .catch((err) => {
                errCheck(err);
            });
    }
    async getExcelshopCategoryId(ids,sName, schild, age_grp, gend,m_stat,spet,s_date,e_date,c_age,min_pri,max_pri,dreason) {
        return await axios({
            url: `/report/shop_category/shop/download`,
            method: 'POST',
            responseType: 'blob', // important
            data: {
                category_id:ids,
                shop_name:sName,
                children:schild,
                user_age_group:age_grp,
                gender:gend,
                marital_status:m_stat,
                pet:spet,
                start_date:s_date,
                end_date:e_date,
                children_age:c_age,
                min_price:min_pri,
                max_price:max_pri,
                reason:dreason,
            },
        }).then((res) => res) .catch((err) => {
            errCheck(err);
        });
    }
    async shopCategoryProductsList(sName,schild, age_grp, gend,m_stat,spet,s_date,e_date,c_age,min_pri,max_pri) {
        return await axios
            .post(`/report/shop_category/products`, {
                store_title:sName,
                children:schild,
                user_age_group:age_grp,
                gender:gend,
                marital_status:m_stat,
                pet:spet,
                start_date:s_date,
                end_date:e_date,
                children_age:c_age,
                min_price:min_pri,
                max_price:max_pri
            })
            .then((res) => res.data.data) .catch((err) => {
                errCheck(err);
            });
    }
    async getExcelshopCategoryProducts(sName,schild, age_grp, gend,m_stat,spet,s_date,e_date,c_age,min_pri,max_pri,dreason) {
        return await axios({
            url: `/report/shop_category/products/download`,
            method: 'POST',
            responseType: 'blob', // important
            data: {
                store_title:sName,
                children:schild,
                user_age_group:age_grp,
                gender:gend,
                marital_status:m_stat,
                pet:spet,
                start_date:s_date,
                end_date:e_date,
                children_age:c_age,
                min_price:min_pri,
                max_price:max_pri,
                reason:dreason,
            },
        }).then((res) => res) .catch((err) => {
            errCheck(err);
        });
    }
     //product_category
    
    async reportCategoryList(pCategory, schild, age_grp, gend,m_stat,spet,s_date,e_date,c_age,min_pri,max_pri) {
        return await axios
            .post(`/report/product_category`, {
                product_category:pCategory,
                children:schild,
                user_age_group:age_grp,
                gender:gend,
                marital_status:m_stat,
                pet:spet,
                start_date:s_date,
                end_date:e_date,
                children_age:c_age,
                min_price:min_pri,
                max_price:max_pri
            })
            .then((res) => res.data.data) .catch((err) => {
                errCheck(err);
            });
    }
    async getExcelproductCategory(pCategory, schild, age_grp, gend,m_stat,spet,s_date,e_date,c_age,min_pri,max_pri,dreason) {
        return await axios({
            url: `/report/product_category_first/download`,
            method: 'POST',
            responseType: 'blob', // important
            data: {
                product_category:pCategory,
                children:schild,
                user_age_group:age_grp,
                gender:gend,
                marital_status:m_stat,
                pet:spet,
                start_date:s_date,
                end_date:e_date,
                children_age:c_age,
                min_price:min_pri,
                max_price:max_pri,
                reason:dreason,
            },
        }).then((res) => res) .catch((err) => {
            errCheck(err);
        });
    }
    //report/product_category_first/download
    async reportCategoryListByCategoryOne(fstCategory,sndcategory, schild, age_grp, gend,m_stat,spet,s_date,e_date,c_age,min_pri,max_pri) {
        return await axios
            .post(`/report/product_category/second`, {
                first_product_category:fstCategory,
                second_product_category:sndcategory,
                children:schild,
                user_age_group:age_grp,
                gender:gend,
                marital_status:m_stat,
                pet:spet,
                start_date:s_date,
                end_date:e_date,
                children_age:c_age,
                min_price:min_pri,
                max_price:max_pri
            })
            .then((res) => res.data.data);
    }
    async getExcelproductCategorySecond(fstCategory,sndcategory, schild, age_grp, gend,m_stat,spet,s_date,e_date,c_age,min_pri,max_pri,dreason) {
        return await axios({
            url: `/report/product_category_second/download`,
            method: 'POST',
            responseType: 'blob', // important
            data: {
                first_product_category:fstCategory,
                second_product_category:sndcategory,
                children:schild,
                user_age_group:age_grp,
                gender:gend,
                marital_status:m_stat,
                pet:spet,
                start_date:s_date,
                end_date:e_date,
                children_age:c_age,
                min_price:min_pri,
                max_price:max_pri,
                reason:dreason,
            },
        }).then((res) => res) .catch((err) => {
            errCheck(err);
        });
    }
    async reportCategoryListByCategoryThird(fstCategory,sndcategory,trdcategory, schild, age_grp, gend,m_stat,spet,s_date,e_date,c_age,min_pri,max_pri) {
        return await axios
            .post(`/report/product_category/third`, {
                first_product_category:fstCategory,
                second_product_category:sndcategory,
                third_product_category:trdcategory,
                children:schild,
                user_age_group:age_grp,
                gender:gend,
                marital_status:m_stat,
                pet:spet,
                start_date:s_date,
                end_date:e_date,
                children_age:c_age,
                min_price:min_pri,
                max_price:max_pri
            })
            .then((res) => res.data.data) .catch((err) => {
                errCheck(err);
            });
    }
    async getExcelproductCategoryThird(fstCategory,sndcategory,trdcategory, schild, age_grp, gend,m_stat,spet,s_date,e_date,c_age,min_pri,max_pri,dreason) {
        return await axios({
            url: `/report/product_category_third/download`,
            method: 'POST',
            responseType: 'blob', // important
            data: {
                first_product_category:fstCategory,
                second_product_category:sndcategory,
                third_product_category:trdcategory,
                children:schild,
                user_age_group:age_grp,
                gender:gend,
                marital_status:m_stat,
                pet:spet,
                start_date:s_date,
                end_date:e_date,
                children_age:c_age,
                min_price:min_pri,
                max_price:max_pri,
                reason:dreason,
            },
        }).then((res) => res) .catch((err) => {
            errCheck(err);
        });
    }
    async reportCategoryListByCategoryFinal(fstCategory,sndcategory,trdcategory, schild, age_grp, gend,m_stat,spet,s_date,e_date,c_age,min_pri,max_pri) {
        return await axios
            .post(`/report/product_category/products`, {
                first_product_category:fstCategory,
                second_product_category:sndcategory,
                third_product_category:trdcategory,
                children:schild,
                user_age_group:age_grp,
                gender:gend,
                marital_status:m_stat,
                pet:spet,
                start_date:s_date,
                end_date:e_date,
                children_age:c_age,
                min_price:min_pri,
                max_price:max_pri
            })
            .then((res) => res.data.data) .catch((err) => {
                errCheck(err);
            });
    }
    async getExcelproductCategoryFinal(fstCategory,sndcategory,trdcategory, schild, age_grp, gend,m_stat,spet,s_date,e_date,c_age,min_pri,max_pri,dreason) {
        return await axios({
            url: `/report/product_category_third/products/download`,
            method: 'POST',
            responseType: 'blob', // important
            data: {
                first_product_category:fstCategory,
                second_product_category:sndcategory,
                third_product_category:trdcategory,
                children:schild,
                user_age_group:age_grp,
                gender:gend,
                marital_status:m_stat,
                pet:spet,
                start_date:s_date,
                end_date:e_date,
                children_age:c_age,
                min_price:min_pri,
                max_price:max_pri,
                reason:dreason,
            },
        }).then((res) => res) .catch((err) => {
            errCheck(err);
        });
    }
    async sendReport(rtype,pCategory) {
        return await axios
            .post(`/report/send_statistic_report`, {
                report_type:rtype,
                product_category:pCategory
            })
            .then((res) => res.data.data) .catch((err) => {
                errCheck(err);
            });
    }
   
}
